import {useQueryWithAccessToken} from "../../../hooks/TanstackHooks";
import {cacheKeys} from "../../../services/shared/serviceConstants";
import {UserConfigTable} from "../../../components/common/Tables/UserConfigTable";
import React from "react";
import {getGridHeadingCount} from "../../../components/common/Tables/Utilities";
import {getSharedMailboxesWithLogin} from '../../../services/shared/SharedMailboxesWithLogin';

export const SharedMailboxWithLoginPanel = () => {

  const {isLoading, data} = useQueryWithAccessToken({
    queryKey: [cacheKeys.sharedMailboxes],
    queryFunction: getSharedMailboxesWithLogin,
    queryFunctionVariables:{}}
  );

  return <>
    {
      <UserConfigTable
        heading={getGridHeadingCount(data, 'Shared Mailboxes with Enabled Login')}
        users={data}
        shouldShowActionColumn={true}
        isLoading={isLoading}
      />
    }
  </>;
}